<template>
	<section class="questions">
		<div class="questions__info">
			<div class="questions__title-main _h2">
				{{ $t('frequently asked questions') }}
			</div>
			<div class="questions__image _ibg-contain">
				<img src="@/assets/images/bg/questions/questions-bg.png" />
			</div>
		</div>

		<div class="questions__items">
			<div
				v-for="(item, index) in sortedQuestions"
				:key="item.id ?? item.order ?? item.question ?? index"
				class="questions__item"
			>
				<button
					class="questions__title _md"
					:class="{ questions__title_active: activeIndex === index }"
					type="button"
					@click="toggleQuestion(index)"
				>
					{{ item.question }}
				</button>

				<div
					class="questions__body"
					:class="{ questions__body_active: activeIndex === index }"
					v-html="item.answer"
				/>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'FaqQuestions',
	props: {
		questions: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			activeIndex: -1,
		};
	},
	computed: {
		sortedQuestions() {
			return [...this.questions].sort(
				(a, b) => (a.order ?? 0) - (b.order ?? 0)
			);
		},
	},
	watch: {
		questions() {
			this.activeIndex = -1;
		},
	},
	methods: {
		toggleQuestion(index) {
			this.activeIndex = this.activeIndex === index ? -1 : index;
		},
	},
};
</script>

<style scoped lang="scss">
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/fonts' as *;
@use '@/assets/styles/components/classes' as *;

.questions {
	@include adaptiveValue('padding-top', 110, 25);
	@include adaptiveValue('padding-bottom', 145, 25);
	@media (min-width: $md2) {
		display: flex;
		gap: 20px;
	}
	&__info {
		position: relative;
		margin-bottom: 20px;
	}
	&__title-main {
		position: relative;
		margin-bottom: 10px;
		@media (max-width: $md2) {
			&:not(:last-child) {
				margin-bottom: 25px;
			}
			&::before {
				@include hide-item;
			}
		}
		&::before {
			content: '';
			position: absolute;
			width: 100%;
			height: 100%;
			@include adaptiveValue('top', 39, 32, 1470, 992, 1);
			transform: translate(0px, -50%);
			left: -101px;
			max-width: 104px;
			z-index: -1;
			background-image: url('@/assets/images/bg/questions/title-bg.png');
			background-repeat: no-repeat;
			background-size: contain;
			background-size: 100% 100%;
			@include adaptiveValue('height', 37, 27, 1470, 992, 1);
		}
	}
	&__image {
		width: 100%;
		padding-bottom: 75%;
		@media (max-width: $md2) {
			@include hide-item;
		}
	}

	&__items {
		display: flex;
		flex-direction: column;
		gap: 8px;
		@media (min-width: $md2) {
			max-width: 710px;
		}
	}
	&__item {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 30, 10);
		}
	}
	&__title {
		color: var(--primary-color);
		font-weight: 700;
		font-family: var(--font-family-inter);
		display: flex;
		align-items: center;
		padding: 8px 70px 8px 40px;
		position: relative;
		background-color: transparent;
		min-width: 100%;
		text-align: left;
		@include adaptiveValue('min-height', 76, 50, 1470, 992, 1);
		@include adaptiveValue('font-size', 24, 18, 1470, 992, 1);
		@media (max-width: $md3) {
			padding: 8px 50px 8px 20px;
		}
		&::before {
			content: '';
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			z-index: -1;
			background-image: url('@/assets/images/bg/questions/title.png');
			background-size: contain;
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}
		&::after {
			content: '';
			position: absolute;
			width: 24px;
			height: 24px;
			top: 50%;
			transform: translate(0px, -50%);
			right: 40px;
			background-image: url('@/assets/images/bg/questions/plus.png');
			background-size: contain;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			transition: background-image 0.3s ease 0s;
			@media (max-width: $md3) {
				right: 15px;
			}
		}
		&_active {
			&::after {
				content: '';
				background-image: url('@/assets/images/bg/questions/minus.png');
			}
		}
	}

	&__body {
		transition: all 0.3s ease 0s;
		opacity: 0;
		height: 0;
		font-size: 16px;
		overflow: hidden;
		font-family: var(--font-family-inter);
		line-height: 150%;
		font-weight: 500;
		position: relative;
		width: 100%;
		margin-top: 0px;
		&::before {
			content: '';
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			z-index: -1;
			background-image: url('@/assets/images/bg/questions/body.png');
			background-size: contain;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			display: flex;
			align-items: center;
		}
		&_active {
			margin-top: 6px;
			height: fit-content;
			padding: 8px 40px;
			opacity: 1;
			@media (max-width: $md3) {
				padding: 8px 20px;
			}
		}
	}
}
</style>
